import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './secondReview.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { SecondReview } from "model/dealer/secondReview.model";

export interface SecondReviewDetailsProps extends DetailsStateAndDispatchProps<SecondReview>,
  RouteComponentProps, StateProps, DispatchProps {
}
const SecondReviewDetails: FC<SecondReviewDetailsProps> = (props) => {
  return (
    <DetailsPage<SecondReview>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<SecondReview>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ secondReview }: RootState) => ({
  entity: secondReview.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SecondReviewDetails);
